import DirectoryTable from "@/directory/DirectoryTable/DirectoryTable";
import useTeacherStudentGetList from "@/teacher/hooks/useTeacherStudentGetList";
import useUser from "@/users/useUser";
import {
  COLUMNS,
  PAGE_SIZE,
  FILTER_UI_PROPS,
} from "./TeacherStudentDirectoryTable.utils";

const TeacherStudentDirectoryTable = () => {
  const { data: user } = useUser();
  const [
    { data: { results: students = [], count = 0 } = {}, loading },
    fetchStudents,
    controls,
  ] = useTeacherStudentGetList(user.teacher.id, PAGE_SIZE);

  const NotFoundMessage = (
    <DirectoryTable.NotFound
      title="No students"
      subTitle="Add students to a class to see them here."
    />
  );

  return (
    <DirectoryTable
      title="Student directory"
      pageSize={PAGE_SIZE}
      columns={COLUMNS}
      data={students}
      initialState={controls}
      totalCount={count}
      loading={loading}
      notFoundMessage={NotFoundMessage}
      onControlsUpdateCb={fetchStudents}
      filterUIProps={FILTER_UI_PROPS}
      filterDefinitions={{}}
    />
  );
};

export default TeacherStudentDirectoryTable;
